import React from 'react'
import DOMPurify from 'dompurify'
import { Tooltip } from '@mui/material'

// Register the hook lazily on the client. Module-level registration breaks
// Next.js static-export prerendering, where dompurify is loaded in Node
// without a DOM and the default export lacks `addHook` until first use.
let hookRegistered = false
const ensureSanitizeHook = () => {
    if (hookRegistered || typeof window === 'undefined') return
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
        // set all links to target=_blank
        if (node.tagName === 'A') {
            node.setAttribute('target', '_blank')
            node.setAttribute('rel', 'noopener')
        }
    })
    hookRegistered = true
}

export default ({ title, children, placement }) => {
    ensureSanitizeHook()
    return (
        <Tooltip
            placement={placement}
            title={
                <div
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(title),
                    }}
                />
            }
            slotProps={{
                popper: {
                    sx: {
                        '& .MuiTooltip-tooltip': {
                            fontSize: '14px',
                            padding: '8px',
                        },
                    },
                },
            }}
        >
            {children}
        </Tooltip>
    )
}
